import React from "react";

// Style
import "./CountControll.scss";

// Classnames
import clsx from "clsx";

// Interface
interface ICount {
  isCart?: boolean,
  className?: string,
  disabled?: boolean,
  innerCount?: number,
  isHideTitle?: boolean,
  innderDisabled?: boolean,
  handlerCallBack?: () => void,
  handlerPlus?: (count: number) => void,
  handlerMinus?: (count: number) => void,
}

export const CountControll: React.FC<ICount> = (props) => {
  const {
    className,
    handlerPlus,
    handlerMinus,
    innerCount = 1,
    isCart = false,
    isHideTitle = false,
    innderDisabled = false
  } = props;

  const handlerChangePlus = () => {
    if (innderDisabled) return;

    handlerPlus && handlerPlus(innerCount + 1);
  };

  const handlerChangeMinus = () => {
    if (innderDisabled) return;

    if (innerCount - 1) {
      handlerMinus && handlerMinus(innerCount - 1);
    }
  };

  const cnWrapper = clsx(
    "count flex flex-ai-start",
    innderDisabled ? "count--active" : "",
    className ? className : "",
    isCart ? "" : "flex-direction-column"
  );

  return (
    <div className={cnWrapper}>
      {!isHideTitle && <p className="count__label mb10">Quantity</p>}

      <div className="count__controll flex flex-ai-center">
        <div
          onClick={handlerChangeMinus}
          className="count__minus flex flex-ai-center flex-jc-center"
        >
          -
        </div>
        <p className="count__result-count">{innerCount}</p>
        <div
          onClick={handlerChangePlus}
          className="count__plus flex flex-ai-center flex-jc-center"
        >
          +
        </div>
      </div>
    </div>
  );
};

export default CountControll;